

export enum LayoutMenuState {
    STATIC                  = 'static',    // menu always shown
    MINIMIZED_BY_USER       = 'minimized-by-user',    // minimized by user
    MINIMIZED_SMALL_SCREEN  = 'minimized-small-screen',     // minimized because screen is small
    APP_NO_MENU             = 'app-no-menu'     // minimized because screen is small
}
